/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { withRouter } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import * as Roles from '../../../constants/role';
import {
  TIPO_NOTA,
  TIPO_NOTA_LEGACY_LABELS,
  TIPO_NOTA_OPTIONS,
  requiresVeiculo,
} from '../../../constants/tipoNota';
import * as selectorsNotas from '../../../store/nota/reducer';
import * as actionsNotas from '../../../store/nota/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import moment from 'moment';

import {
  InputV2,
  DefaultSelectV2,
  TrueFalseSelectV2,
  DialogDefaultV2,
  ArquivoContainerV2,
  DatePickerV2,
  NumberInputV2,
  UsuarioSelectV2,
  ValidateSelectV2,
  VeiculoSelectV2,
  CartaoSelectV2,
} from '../../../components/v2';
import ManutencaoVeicularContainer from './ManutencaoVeicularContainer';
import PecasManutencaoContainer from './PecasManutencaoContainer';

const schema = {
  valor: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  tipo: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  possuiCupom: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  tipoPagamento: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  inspecao: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const tipoPagamentoOptions = [
  { id: 'APORTE', nome: 'Aporte' },
  { id: 'CARTAO_CORPORATIVO', nome: 'Cartão Corporativo' },
];

const Formulario = ({
  saveNota,
  updateNota,
  selectedNota,
  open,
  id,
  onClose,
  findNotaById,
  authData,
  isAdmin,
}) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [readOnly, setReadOnly] = useState(false);

  useEffect(() => {
    if (open) {
      setValues({
        data: moment().valueOf(),
        usuarioNome: authData.nome,
        dataInclusao: moment().format('DD/MM/YYYY HH:mm:ss'),
      });
    } else {
      setValues({});
    }
  }, [authData, open]);

  useEffect(() => {
    if (id) findNotaById(id);
  }, [id, findNotaById]);

  const toTrueFalseSelectValue = (value) => {
    if (value === true || value === 'true') return 'true';
    if (value === false || value === 'false') return 'false';
    return '';
  };

  useEffect(() => {
    if (id && selectedNota && id === selectedNota.id) {
      const nota = { ...selectedNota };
      if (!nota.data) nota.data = moment().valueOf();
      else nota.data = Number(nota.data);
      nota.foraEstado = toTrueFalseSelectValue(nota.foraEstado);
      nota.possuiImpostoEmpresa = toTrueFalseSelectValue(nota.possuiImpostoEmpresa);
      setValues(nota);
      setReadOnly(isAdmin ? false : (nota.validate === 'VALIDADO' || nota.validate === 'INVALIDADO'));
    } else if (open && !id) {
      setValues({
        data: moment().valueOf(),
        usuarioNome: authData.nome,
        dataInclusao: moment().format('DD/MM/YYYY HH:mm:ss'),
      });
      setReadOnly(false);
    }
  }, [id, selectedNota, authData, isAdmin, open]);

  const isFlagEmpty = (value) => value === null || value === undefined || value === '';

  const onSave = () => {
    const erros = validate(values, schema) || {};
    if (validateCartaoCorporativo()) erros.cartao = true;
    if (validateJustificativa()) erros.justificativa = true;
    if (validateArquivo()) erros.arquivo = true;
    if (isAdmin && values.validate === 'VALIDADO') {
      if (isFlagEmpty(values.foraEstado)) erros.foraEstado = true;
      if (isFlagEmpty(values.possuiImpostoEmpresa)) erros.possuiImpostoEmpresa = true;
    }

    setErrors(erros);
    if (!erros || Object.keys(erros).length === 0) {
      const payload = { ...values };
      if (payload.file) {
        payload.arquivo = {
          nome: payload.file.name.split('.')[0],
          extensao: payload.file.name.split('.').pop(),
          status: 'NOT_SYNC',
        };
      }

      if (payload.id) updateNota(payload, saveCallback);
      else saveNota(payload, saveCallback);
    }
  };

  const saveCallback = (success) => {
    if (success) {
      onCloseLocal(true);
    }
  };

  const onCloseLocal = (isSave) => {
    setErrors({});
    setValues({});
    onClose(isSave);
  };

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const isNotInspecao = () => values.inspecao === 'false' || values.inspecao === false;
  const validateCartaoCorporativo = () => values.tipoPagamento === 'CARTAO_CORPORATIVO' && !values.cartao;
  const validateArquivo = () => values.possuiCupom === 'true' && (!values.arquivos || values.arquivos.length === 0);
  const validateJustificativa = () => (isNotInspecao() || values.tipo === TIPO_NOTA.OUTROS) && !values.justificativa;

  const tipoNotaOptions = useMemo(() => {
    if (values.tipo && TIPO_NOTA_LEGACY_LABELS[values.tipo]) {
      return [
        ...TIPO_NOTA_OPTIONS,
        { id: values.tipo, nome: TIPO_NOTA_LEGACY_LABELS[values.tipo] },
      ];
    }
    return TIPO_NOTA_OPTIONS;
  }, [values.tipo]);

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Nota"
      confirmMessage="Salvar"
      maxWidth="md"
      fullWidth
      readOnly={readOnly}
    >
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, sm: 3 }}>
          <NumberInputV2
            error={!!(errors && errors.valor)}
            isRequired
            label="Valor"
            onChange={(valor) => setValues({ ...values, valor })}
            value={values.valor}
            decimalScale={6}
            decimalSeparator=","
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <DatePickerV2
            label="Data"
            onChange={(data) =>
              setValues({
                ...values,
                data,
              })
            }
            value={values.data}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <InputV2 label="Criado Por" value={values.usuarioNome || ''} disabled />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <InputV2 label="Data Inclusão" value={values.dataInclusao || ''} disabled />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <DefaultSelectV2
            error={!!(errors && errors.tipo)}
            isRequired
            label="Tipo da Nota"
            name="tipo"
            showEmpty
            options={tipoNotaOptions}
            onSelect={(event) => {
              setValues({
                ...values,
                [event.target.name]: event.target.value,
                veiculoId: requiresVeiculo(event.target.value) ? values.veiculoId : null,
                usuarioAdiantamentoId: null,
              });
            }}
            value={values.tipo}
            disabled={readOnly}
          />
        </Grid>
        {requiresVeiculo(values.tipo) && (
          <Grid size={{ xs: 12, sm: 3 }}>
            <VeiculoSelectV2
              onSelect={(veiculoId) => {
                setValues({ ...values, veiculoId });
              }}
              value={requiresVeiculo(values.tipo) ? values.veiculoId : ''}
              isRequired={requiresVeiculo(values.tipo)}
              disabled={readOnly || !values || !requiresVeiculo(values.tipo)}
            />
          </Grid>
        )}
        <Grid size={{ xs: 12, sm: 3 }}>
          <ValidateSelectV2
            onChange={(validateStatus) =>
              setValues({ ...values, validate: validateStatus })
            }
            value={values.validate}
            disabled={!isAdmin}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <TrueFalseSelectV2
            error={!!(errors && errors.possuiCupom)}
            isRequired
            label="Cupom Fiscal/NF"
            name="possuiCupom"
            onChange={handleChange}
            value={values.possuiCupom}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <DefaultSelectV2
            error={!!(errors && errors.tipoPagamento)}
            isRequired
            label="Tipo do Pagamento"
            name="tipoPagamento"
            showEmpty
            options={tipoPagamentoOptions}
            onSelect={(event) =>
              setValues({
                ...values,
                tipoPagamento: event.target.value,
                cartao: undefined,
              })
            }
            value={values.tipoPagamento}
            disabled={readOnly}
          />
        </Grid>
        {values.tipoPagamento === 'CARTAO_CORPORATIVO' && (
          <>
            <Grid size={{ xs: 12, sm: 3 }}>
              <CartaoSelectV2
                error={!!(errors && errors.cartao)}
                onSelect={(cartao) => {
                  setValues({ ...values, cartao });
                }}
                value={values.cartao}
                disabled={readOnly || (values && values.tipoPagamento !== 'CARTAO_CORPORATIVO')}
                isRequired={values.tipoPagamento === 'CARTAO_CORPORATIVO'}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 3 }}>
              <TrueFalseSelectV2
                error={!!(errors && errors.despesaFatura)}
                label="Despesa na Fatura"
                name="despesaFatura"
                onChange={handleChange}
                value={values.despesaFatura}
                disabled={readOnly}
              />
            </Grid>
          </>
        )}
        {isAdmin && (
          <>
            <Grid size={{ xs: 12, sm: 3 }}>
              <TrueFalseSelectV2
                error={!!(errors && errors.foraEstado)}
                isRequired={values.validate === 'VALIDADO'}
                label="Fora do estado (MG)"
                name="foraEstado"
                onChange={handleChange}
                value={values.foraEstado}
                disabled={readOnly}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 3 }}>
              <TrueFalseSelectV2
                error={!!(errors && errors.possuiImpostoEmpresa)}
                isRequired={values.validate === 'VALIDADO'}
                label="Imposto a pagar (empresa)"
                name="possuiImpostoEmpresa"
                onChange={handleChange}
                value={values.possuiImpostoEmpresa}
                disabled={readOnly}
              />
            </Grid>
          </>
        )}
        <Grid size={{ xs: 12, sm: 3 }}>
          <TrueFalseSelectV2
            error={!!(errors && errors.inspecao)}
            isRequired
            label="É Inspeção"
            name="inspecao"
            onChange={handleChange}
            value={values.inspecao}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <UsuarioSelectV2
            label="Ajudante/Observador"
            onSelect={(inspetorAuxiliar) =>
              setValues({ ...values, inspetorAuxiliar })
            }
            ativo
            grupos={[Roles.ADMIN, Roles.INSPETOR]}
            value={values.inspetorAuxiliar}
            disabled={readOnly}
          />
        </Grid>
        {values.tipo === TIPO_NOTA.MANUTENCAO_VEICULO && (
          <ManutencaoVeicularContainer
            manutencoes={values.manutencoes || []}
            onSave={(manutencoes) => setValues({ ...values, manutencoes })}
            readOnly={readOnly}
          />
        )}
        {values.tipo === TIPO_NOTA.COMPRA_MANUTENCAO_VEICULAR && (
          <PecasManutencaoContainer
            pecas={values.compraNotas || []}
            onSave={(compraNotas) => setValues({ ...values, compraNotas })}
            readOnly={readOnly}
          />
        )}
        <Grid size={{ xs: 12 }}>
          <InputV2
            error={!!(errors && errors.justificativa)}
            label="Justificativa"
            name="justificativa"
            onChange={handleChange}
            value={values.justificativa || ''}
            rows={3}
            multiline
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            **Caso não possua cupom fiscal deve se preencher o campo de justificativa
          </Typography>
          {errors && errors.arquivo ? (
            <Typography variant="caption" color="error" sx={{ display: 'block' }}>
              ***Arquivo(s) é obrigatório(s)
            </Typography>
          ) : null}
        </Grid>
        <Grid size={{ xs: 12 }}>
          <ArquivoContainerV2
            arquivos={values.arquivos}
            onSave={(arquivos) => setValues({ ...values, arquivos })}
            disabled={readOnly}
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

Formulario.propTypes = {
  findNotaById: PropTypes.func.isRequired,
  saveNota: PropTypes.func.isRequired,
  updateNota: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  selectedNota: PropTypes.object,
  authData: PropTypes.object,
  isAdmin: PropTypes.bool.isRequired,
};

Formulario.defaultProps = {
  selectedNota: null,
  id: null,
  authData: {},
};

const mapStateToProps = (state) => ({
  selectedNota: selectorsNotas.getSelectedNota(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...actionsNotas,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
